module.exports = __webpack_public_path__ + "img/cardbutton2.b68cb743.jpg";